import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/idnp-automations/')({
  beforeLoad: ({ context, params, preload }) => {
    const isAllowed = !!context.featureFlags[FeatureFlags.GartnerDemo];
    context.validatePermissions({ isAllowed, preload });
    throw redirect({ to: '/$accountId/platform/idnp-automations/playbooks', search: true, params });
  },
});
